import { Controller } from "@hotwired/stimulus"

// Sets a progress bar's width from a data value via the CSSOM, so we never emit
// an inline style="" attribute (which CSP would block).
export default class extends Controller {
  static values = { percent: Number }

  percentValueChanged() { this.render() }

  render() {
    this.element.style.width = `${Math.max(0, Math.min(100, this.percentValue))}%`
  }
}
